module.exports = __webpack_public_path__ + "img/mod-11.eb2124a9.svg";